class Rec {
    constructor(apiService = null) {
        this.obj_name = 'rec';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // API 方法
    // 食譜 | 101 取得歷史食譜
    async getRecipeHistoryByMedicalRecordId(parameter) {
        return this.callApi('get', 'getRecipeHistoryByMedicalRecordId', parameter);
    }

    // 食譜 | 102 取得最新食譜
    async getCurrentRecipeByMedicalRecordId(parameter) {
        return this.callApi('get', 'getCurrentRecipeByMedicalRecordId', parameter);
    }

    // 食譜 | 103 新增食譜
    async addRecipeWithJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addRecipeWithJson', parameter, progressEvent);
    }
}

export default Rec;
